// extracted by mini-css-extract-plugin
export default {"dashboard-billing":"style_dashboard-billing__Rbt8F","dashboard-billing-content":"style_dashboard-billing-content__KyjON"};